import React from 'react';
import { StyledPhoneInput } from './styles';

const PhoneInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => {
  return (
    <StyledPhoneInput
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      ref={ref}
      {...props}
    />
  );
});

export default PhoneInput;
